export const colorPicker = (type: string) => {
  switch (type) {
    case 'self':
      return 'malibu'

    case 'manager':
      return 'purple'

    case 'direct_reports':
      return 'yellow'

    case 'peers':
      return 'flubber'

    default:
      return 'smoke'
  }
}
